export enum ECitizen {
  SingaporeCitizen = 'SingaporeCitizen',
  SingaporePr = 'SingaporePr',
  Foreigner = 'Foreigner',
}
